export const routes = (parentName) => {
  return [
    {
      path: 'random-number-requests',
      component: () => import('./Index.vue'),
      children: [
        {
          path: '',
          name: `${parentName}-RandomNumberRequests`,
          component: () => import('./List.vue'),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: 'new',
          name: `${parentName}-RandomNumberRequests-New`,
          component: () => import('./Upsert.vue'),
        },
        {
          path: ':id',
          name: parentName + '-' + 'RandomNumberRequests-View',
          component: () => import('./View.vue'),
        },
        {
          path: ':id/edit',
          name: parentName + '-' + 'RandomNumberRequests-Edit',
          component: () => import('./Upsert.vue'),
        },
      ],
    },
  ];
};
